(function () {
  if (window.__charmPopupInitialized) return;
  window.__charmPopupInitialized = true;
  const CHARM_DATA = JSON.parse(document.getElementById('charm-products-data')?.textContent || '[]');
  if (!CHARM_DATA.length) {
    console.warn('Charm popup: no charm data found');
    return;
  }

  const CHECKOUT_SELECTOR = 'input[type="submit"][name="checkout"], button[name="checkout"]';

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function getLiveProductData(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      return res.json();
    } catch (e) {
      return null;
    }
  }

  function cartHasAnyCharm(cart, charmVariantIds) {
    return cart.items.some(item => charmVariantIds.includes(item.variant_id));
  }

  function pickRandom(arr, n) {
    const copy = [...arr];
    const out = [];
    while (out.length < n && copy.length) {
      const i = Math.floor(Math.random() * copy.length);
      out.push(copy.splice(i, 1)[0]);
    }
    return out;
  }

  async function buildEligibleList() {
    const liveChecks = await Promise.all(CHARM_DATA.map(c => getLiveProductData(c.handle)));
    const eligible = [];
    liveChecks.forEach((live) => {
      if (!live || !live.available) return;
      const variant = live.variants.find(v => v.available);
      if (variant) {
        eligible.push({
          title: live.title,
          image: live.featured_image || '',
          variantId: variant.id
        });
      }
    });
    return eligible;
  }

  async function addToCartAndCheckout(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    window.location.href = '/checkout';
  }

  function showModal(options) {
    const overlay = document.createElement('div');
    overlay.className = 'charm-modal-overlay';
    overlay.innerHTML = `
      <div class="charm-modal">
        <h3>Alege un charm!</h3>
        <div class="charm-options">
          ${options.map(o => `
            <button type="button" class="charm-option" data-variant-id="${o.variantId}">
              <img src="${o.image}" alt="${o.title}">
              <span>${o.title}</span>
              <br/>
              <span style="font-size:70%;">4.99 RON</span>
            </button>
          `).join('')}
        </div>
        <button type="button" class="charm-decline">Nu vreau charms, mersi.</button>
      </div>
    `;
    document.body.appendChild(overlay);

    overlay.querySelectorAll('.charm-option').forEach(btn => {
      btn.addEventListener('click', () => {
        addToCartAndCheckout(parseInt(btn.dataset.variantId, 10));
      });
    });
    overlay.querySelector('.charm-decline').addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }

  let processing = false;

  async function handleCheckoutClick(e) {
    if (!e.target.closest(CHECKOUT_SELECTOR)) return; // not our button, ignore

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (processing) return; // avoid double-fires
    processing = true;

    try {
      const cart = await getCart();
      const charmVariantIds = CHARM_DATA.map(c => c.variantId);

      if (cartHasAnyCharm(cart, charmVariantIds)) {
        window.location.href = '/checkout';
        return;
      }

      const eligible = await buildEligibleList();

      if (eligible.length < 3) {
        window.location.href = '/checkout';
        return;
      }

      const chosen = pickRandom(eligible, 3);
      showModal(chosen);
    } finally {
      processing = false;
    }
  }

  // Capture phase on document = fires before the theme's own listeners
  document.addEventListener('click', handleCheckoutClick, true);
})();